import React from "react";

const OurTeamsHeroSection = () => (
  <section className="relative pt-32 pb-10 lg:pt-16 lg:pb-16 overflow-hidden bg-slate-50">
    {/* Background Blobs */}
    <div className="absolute top-0 right-0 -z-10 opacity-30 translate-x-1/3 -translate-y-1/4 pointer-events-none">
      <div className="w-[800px] h-[800px] bg-blue-200 rounded-full blur-3xl mix-blend-multiply filter"></div>
    </div>
    <div className="absolute bottom-0 left-0 -z-10 opacity-30 -translate-x-1/3 translate-y-1/4 pointer-events-none">
      <div className="w-[600px] h-[600px] bg-indigo-200 rounded-full blur-3xl mix-blend-multiply filter"></div>
    </div>

    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h1
        className="text-5xl md:text-7xl font-bold text-slate-900 tracking-tight mb-6 animate-fade-in-up"
        style={{ animationDelay: "0.1s" }}
      >
        {/* Meet the{" "} */}
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-blue-900">
          Leadership
        </span>
      </h1>
      <p
        className="text-xl text-gray-600 max-w-2xl mx-auto mb-10 leading-relaxed animate-fade-in-up"
        style={{ animationDelay: "0.2s" }}
      >
        Intellectsoft Executive Leadership and Senior Management bring decades
        of industry experience, a global perspective and a passion for achieving
        results.
      </p>
      <div
        className="flex justify-center gap-4 animate-fade-in-up"
        style={{ animationDelay: "0.3s" }}
      >
        <a
          href="#team"
          className="px-8 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition shadow-xl shadow-blue-500/20 flex items-center"
        >
          View Team
        </a>
        {/* <a
          href="#culture"
          className="px-8 py-3 bg-white text-gray-700 border border-gray-200 rounded-lg font-semibold hover:bg-gray-50 transition flex items-center"
        >
          Our Culture
        </a> */}
      </div>
    </div>
  </section>
);

export default OurTeamsHeroSection;
